import GenerateFileForm from './GenerateFileForm';

export default GenerateFileForm;
